export const INITIAL_WOW_DURATION = 0;
export const INITIAL_WOW_DELAY = 0;
export const TEAM_DESCRIPTION =
  'We are a highly skilled team of developers, dedicated problem solvers, and enthusiastic collaborators. Our core belief is in crafting exceptional software solutions, leveraging our expertise to tackle complex challenges. We are committed to delivering outstanding code quality, innovative solutions, and fostering a culture of excellence. Join us on our journey to build the future of technology.';
export const TEAM_DESCRIPTION_TITLE = 'Unity is strength';
export const ABOUT_US_PATH = 'about-us';
export const TEAM_PRINCIPLES = 'Team Principles';
export const OUR_SERVICES = 'Our Services';
